import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";
import registerReducer from "../routes/register/registerSlice";
import loginReducer from "../routes/login/loginSlice";
import homeReducer from "../routes/home/homeSlice";
import vehiclesReducer from "../routes/home/vehicles/vehiclesSlice";
import cardsReducer from "../routes/home/cardsAndBadges/cards/cardsSlice";
import rulesReducer from "../routes/home/rules/rulesSlice";
import usersReducer from "../routes/home/users/usersSlice";
import driversReducer from "../routes/home/drivers/driversSlice";
import transactionsReducer from "../routes/home/transactions/transactionsSlice";
import billingsReducer from "../routes/home/billings/billingsSlice";
import stripeReducer from "../routes/stripe/stripeSlice";
import companiesSlice from "../routes/home/companies/companiesSlice";
import sepaDebitReducer from "../routes/home/billings/sepaDebitSlice";
import badgesReducer from "../routes/home/cardsAndBadges/badges/badgesSlice";
import fleetReducer from "../routes/home/fleet/fleetSlice";
import tripsReducer from "../routes/home/fleet/trips/tripsSlice";
import driverPlanningsReducer from "../routes/home/fleet/driverPlannings/driverPlanningsSlice";
import vehicleContractDataReducer from "../routes/home/fleet/advancedAnalytics/contractFollowUp/vehicleContractDataSlice";
import electrificationReducer from "../routes/home/electrification/electrificationSlice";
import notificationsReducer from "../routes/home/notifications/notificationsSlice";
import departmentsReducer from "../routes/home/departments/departmentsSlice";
import departmentsForDepartmentUserReducer from "../routes/homeDepartments/departments/departmentsSlice";
import geolocationReducer from "../routes/home/geolocation/geolocationSlice";
import electricChargingReducer from "../routes/home/electricCharging/electricChargingSlice";
import linkyConsentsReducer from "../routes/home/electricCharging/linkyConsentsSlice";
import electricVehiclesReducer from "../routes/home/electricCharging/electricVehiclesSlice";

export const store = configureStore({
  reducer: {
    register: registerReducer,
    login: loginReducer,
    home: homeReducer,
    vehicles: vehiclesReducer,
    cards: cardsReducer,
    rules: rulesReducer,
    users: usersReducer,
    drivers: driversReducer,
    transactions: transactionsReducer,
    billings: billingsReducer,
    stripe: stripeReducer,
    companies: companiesSlice,
    sepaDebit: sepaDebitReducer,
    badges: badgesReducer,
    fleet: fleetReducer,
    trips: tripsReducer,
    driverPlannings: driverPlanningsReducer,
    vehicleContractData: vehicleContractDataReducer,
    electrification: electrificationReducer,
    notifications: notificationsReducer,
    departments: departmentsReducer,
    departmentsForDepartmentUser: departmentsForDepartmentUserReducer,
    geolocation: geolocationReducer,
    electricCharging: electricChargingReducer,
    linkyConsents: linkyConsentsReducer,
    electricVehicles: electricVehiclesReducer,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
